export default __webpack_public_path__ + "static/media/pin.4f9d9700.png";